import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CaseListingInstanceState } from 'app/area/case-report/case-listing/types-store';
import { RenderMode } from 'app/types-shared';
import { TileProps } from 'ui/tile/tile';

export const editDocumentItemVisibility = (
  state: CaseState | CaseListingInstanceState,
  uiEngineProps: ConnectedComponentProps
): Partial<TileProps> => {
  const {
    showDetailsEditButton
  } = uiEngineProps.componentDescriptor.properties;
  const { renderMode } = state;

  return {
    showDetailsEditButton:
      uiEngineProps.enabledEntityOperations && 
      uiEngineProps.enabledEntityOperations.edit && 
      showDetailsEditButton && 
      renderMode === RenderMode.read
  };
};
